<template>
  <v-container
    id="report"
    fluid
    tag="section"
  >
    <filter-form :filter-form="filterForm" />
    <call-center-table :reports="reports"/>
    <call-center-chart v-if="dataChart.labels.length && showChart" :dataChart="dataChart" :reports="reports"/>
  </v-container>
</template>
<script>
  import FilterForm from './components/FilterForm'
  import CallCenterTable from './components/CallCenterTable'
  import CallCenterChart from './components/CallCenterChart'
  import { formatDate } from '../../../helpers/utils'
  import * as moment from 'moment'
  import RepositoryFactory from '../../../repositories/RepositoryFactory'

  const CallCenterRespository = RepositoryFactory.get('call_center')
  export default {
    components: { FilterForm, CallCenterTable, CallCenterChart },
    data () {
      return {
        filterForm: {
          dateRange: {
            startDate: moment().startOf('isoWeek').format('YYYY-MM-DD'),
            endDate: moment().endOf('isoWeek').format('YYYY-MM-DD'),
          },
          shift: [],
          storeId: 0
        },
        reports: {},
        minuteChartData: [],
        dataChart: {
          labels: [],
          tValues: [],
          cValues: [],
        },
        showChart: false
      }
    },
    created () {
      this.getReportList()
      Bus.$on('report-list-filter', (filterForm) => {
        this.filterForm = filterForm
        this.getReportList()
        this.showChart = filterForm.shift.length == 0 ? false : true
      })
    },
    beforeDestroy() {
      Bus.$off('report-list-filter');
    },
    methods: {
      async getReportList () {
        this.loading = true
        const params = {
          startDate: formatDate(this.filterForm.dateRange.startDate),
          endDate: formatDate(this.filterForm.dateRange.endDate),
          shift: this.filterForm.shift,
          storeId: this.filterForm.storeId,
        }
        // const loader = this.$loading.show()
        this.appLoadingData(true)
        const response = await CallCenterRespository.reportList(params)
        // loader.hide()
        this.appLoadingData(false)
        this.loading = false
        if (response.success) {
          this.reports = _.get(response, 'data', {})
          this.minuteChartData =  _.get(response, 'data.minuteChartData', [])
        }
        this.getMultiLineData();
      },
      getMultiLineData() {
        this.dataChart.tValues = [];
        this.dataChart.cValues = [];
        this.dataChart.labels = this.minuteChartData.map(value => Object.keys(value)[0])
        const d = this.minuteChartData.map(value => value[Object.keys(value)[0]])
        if(+this.filterForm.storeId === 0 || +this.filterForm.storeId === 2) {
          this.dataChart.tValues = d.map(v => v.T || 0).map(function(v) {
            return (+v / 60).toFixed(2);
          });
        }
        if(+this.filterForm.storeId === 0 || +this.filterForm.storeId === 1) {
          this.dataChart.cValues = d.map(z => z.C || 0).map(function (z) {
            return (+z / 60).toFixed(2);
          });
        }
        Bus.$emit('data-chart-filter', this.dataChart)
      }
    },
  }
</script>
